import styled from '@emotion/styled';
import Box from 'components/Box';

const NotificationWrapper = styled('div')`
  border-radius: 10px;
  width: calc(100% - ${(props) => props.left}px);
  z-index: 1;
  position: fixed;
  max-height: 30%;
  bottom: 0;
  transform: translateY(${(props) => (props.show ? '0' : '100%')});
  transition: transform 0.25s;
  left: ${(props) => props.left}px;
  text-align: center;
  background-color: var(--${(props) => props.color === 'success' ? 'success-color' : 'primary-color'});
  display: flex;
  font-size: 20px;
  align-items: center;
  min-height: 80px;
  box-shadow: 0px 3px 10px var(--box-shadow-color);
  margin-bottom: 16px;
  padding: 16px 28px 16px 24px;

  @media (max-width: 767px) {
    left: 50%;
    transform: translateX(-50%) translateY(${(props) => (props.show ? '0' : '100%')});
    width: 90%;
  }

  @media (min-width: 768px) {
    right: 20px;
  }
`;

const CloseButton = styled.button(() => ({
  width: 20, 
  height: 20, 
  background: 'rgba(255,255,255,0.15)',
  border: '0 !important',
  borderRadius: '50%',
  position: 'absolute',
  top: 5,
  right: 5, 
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,
}));

const Icon = styled(Box)({
  borderRadius: '50%',
  backgroundColor: 'rgba(232,212,223,0.8)',
  padding: '11px 11px',
  display: 'flex',
  marginRight: '16px',
})

const TextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
  font-weight: 600;
`;

export { NotificationWrapper, CloseButton, Icon, TextWrapper };